import {HospitalInvoiceList} from "./HospitalInvoiceList";
import {HospitalInvoiceEdit} from "./HospitalInvoiceEdit";
import {HospitalInvoiceCreate} from "./HospitalInvoiceCreate";

export default {
    list: HospitalInvoiceList,
    create: HospitalInvoiceCreate,
    edit: HospitalInvoiceEdit
};
